import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { BRAND_ORANGE } from '../../../../styles/portalTheme';

const ArchiveEventDialog = ({ open, event, archiving = false, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={archiving ? undefined : onClose}
    PaperProps={{
      sx: {
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
      },
    }}
  >
    <DialogContent sx={{ pb: 1, pt: 1 }}>
      <Box
        sx={{
          width: 60,
          height: 60,
          borderRadius: '50%',
          bgcolor: (theme) => theme.portal?.accentSoft ?? theme.palette.action.hover,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mx: 'auto',
          mb: 2,
        }}
      >
        <ArchiveOutlinedIcon sx={{ fontSize: 32, color: BRAND_ORANGE }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Archive Event?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
        Archive{' '}
        <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {event?.title ?? 'this event'}
        </Box>
        ? It will move to your Archived tab and will no longer appear in active lists. You can still
        view it from Archived.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center', gap: 2, pb: 1, pt: 2 }}>
      <Button
        variant="outlined"
        disabled={archiving}
        onClick={onClose}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          color: BRAND_ORANGE,
          borderColor: BRAND_ORANGE,
          '&:hover': {
            borderColor: 'primary.dark',
            bgcolor: 'rgba(224, 104, 10, 0.04)',
          },
        }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        disabled={archiving}
        onClick={onConfirm}
        sx={{
          minWidth: 120,
          height: 44,
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 1.5,
          bgcolor: BRAND_ORANGE,
          boxShadow: 'none',
          '&:hover': {
            bgcolor: 'primary.dark',
            boxShadow: 'none',
          },
        }}
      >
        {archiving ? 'Archiving…' : 'Archive'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ArchiveEventDialog;
